import useOptions from "../useSelectOptions/useSelectOptions";
import { mapDataToOptions } from "../../../utils/mapDataToOptions";

const useOtherOptions = (endpoint) => {
  return useOptions(endpoint, mapDataToOptions);
};

export default useOtherOptions;
